import axiosInstance from "../../axiosInstance";

const BASE_URL = "/finance/payment";

export const getAllPaymentRequests = async () => {
  const res = await axiosInstance.get(BASE_URL);
  return res.data.records;
};

export const getPaymentDetail = async (id) => {
  const res = await axiosInstance.get(`${BASE_URL}/${id}`);
  return res.data;
};

export const createPaymentRequest = async (data) => {
  const res = await axiosInstance.post(BASE_URL, data);
  return res.data;
};

export const submitPaymentRequest = async (id) => {
  const res = await axiosInstance.post(`${BASE_URL}/${id}/submit`);
  return res.data;
};

export const remindPaymentApprovers = async (id) => {
  const res = await axiosInstance.post(`${BASE_URL}/${id}/remind`);
  return res.data;
};

export const approvePayment = async (id) => {
  const res = await axiosInstance.patch(`${BASE_URL}/${id}/approve`);
  return res.data;
};

export const rejectPayment = async (id, reject_reason) => {
  const res = await axiosInstance.patch(`${BASE_URL}/${id}/reject`, {
    reject_reason,
  });
  return res.data;
};

export const addPaymentTransaction = async (id, data) => {
  const res = await axiosInstance.post(`${BASE_URL}/${id}/pay`, data);
  return res.data;
};

export const deletePaymentRequest = async (id) => {
  const res = await axiosInstance.delete(`${BASE_URL}/${id}`);
  return res.data;
};

export const getPaymentApprovalRules = async (params = {}) => {
  const rel = `${BASE_URL}/approval-rules`;
  try {
    const res = await axiosInstance.get(rel, {
      params,
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};
